import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Switch, 
  IconButton, 
  Box,
  CircularProgress
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function ConfigCard({
  title,
  enabled = false,
  loading = false,
  onToggle,
  expanded = false,
  onExpand,
  showExpandButton = false,
  showToggle = true,
  variant = 'elevation',
  sx = {},
  children
}) {
  return (
    <Card 
      variant={variant}
      sx={{ 
        mb: 2,
        ...sx
      }}
    >
      <CardContent sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        '&:last-child': { pb: 2 }
      }}>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {showToggle && (
            <Box sx={{ position: 'relative', display: 'inline-flex', mr: 2 }}>
              <Switch
                checked={enabled}
                onChange={onToggle}
                disabled={loading}
              />
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                    color: 'primary.main',
                  }}
                />
              )}
            </Box>
          )}
          {showExpandButton && (
            <IconButton onClick={onExpand}>
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          )}
        </Box>
      </CardContent>
      {expanded && children}
    </Card>
  );
}

export default ConfigCard; 